import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';
import React from 'react';

const TableOfContent = ({ refs }) => {
  const tableOfContent = [
    { title: 'Background', ref: refs.backGroundRef },
    {
      title:
        'How do we collect personal data from users of Topibro Tech facilities and services?',
      ref: refs.howWeCollectDataRef,
    },
    { title: 'Data Retention', ref: refs.dataRetentionRef },
    { title: 'Cookies Policy', ref: refs.cookiesPolicyRef },
    { title: 'Data Subject Rights', ref: refs.dataSubjectRightRef },
  ];

  return (
    <Box>
      <Typography
        variant="h3"
        sx={{
          fontWeight: 200,
          textAlign: 'left',
          my: 2,
          textTransform: 'capitalize',
        }}
      >
        Table of Contents
      </Typography>
      {tableOfContent.map((item, i) => (
        <Box
          key={i}
          sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'left',
            alignItems: 'center',
          }}
        >
          <Typography sx={{ marginY: 1, ml: 2 }}>{i + 1}.</Typography>
          <Typography
            component="a"
            onClick={() =>
              item.ref.current.scrollIntoView({ behavior: 'smooth' })
            }
            sx={{
              textTransform: 'capitalize',
              display: 'flex',
              flexDirection: 'column',
              color: 'purple',
              cursor: 'pointer',
              marginY: 1,
              ml: 2,
              textDecoration: 'none',
              '&:hover': {
                textDecoration: 'underline',
              },
            }}
          >
            {item.title}
          </Typography>
        </Box>
      ))}
    </Box>
  );
};

TableOfContent.propTypes = {
  refs: PropTypes.object,
};

export default TableOfContent;
